import { loginByResuming, loginByCredentials, signupByCredentials, logoutUser, } from 'api/user-api';
import { ApiConnection } from '@newtontechnologies/beey-api-js-client/connection';
import { Result } from 'monadix/result';
import { fetchCurrentTeamSettings } from './team-api';
export class OpenedSession {
    constructor(connection, login, teamSettings) {
        this.connection = connection;
        this.login = login;
        this.teamSettings = teamSettings;
    }
    withLogin(login) {
        return new OpenedSession(this.connection, login, this.teamSettings);
    }
    withUser(user) {
        return this.withLogin(this.login.withUser(user));
    }
    withTeamSettings(teamSettings) {
        return new OpenedSession(this.connection, this.login, teamSettings);
    }
    async explicitLogout() {
        const logoutResult = await logoutUser(this.connection);
        await this.connection.close();
        if (logoutResult.isSuccess()) {
            const logout = logoutResult.get();
            if (logout.redirectUrl !== null) {
                window.location.href = logout.redirectUrl;
            }
            return true;
        }
        return false;
    }
}
const setupConnection = (clearSession) => {
    const connection = new ApiConnection();
    connection.on('close', () => {
        clearSession();
    });
    return connection;
};
export const openByResuming = async (clearSession) => {
    const loginResult = await loginByResuming();
    if (loginResult.isFail()) {
        return loginResult;
    }
    const connection = setupConnection(clearSession);
    const teamSettings = await fetchCurrentTeamSettings(connection);
    return Result.success(new OpenedSession(connection, loginResult.get(), teamSettings));
};
export const openByCredentials = async ({ email, password }, dataProtectionConsent, clearSession) => {
    const loginResult = await loginByCredentials(email.trim(), password, dataProtectionConsent);
    if (loginResult.isFail()) {
        return loginResult;
    }
    const login = loginResult.get();
    const connection = setupConnection(clearSession);
    const teamSettings = await fetchCurrentTeamSettings(connection);
    return Result.success(new OpenedSession(connection, login, teamSettings));
};
export const openByRegistering = async (email, password, uiLocale, userOrigin, userField, clearSession) => {
    const loginResult = await signupByCredentials(email.trim(), password, uiLocale, userOrigin, userField);
    if (loginResult.isSuccess()) {
        const connection = setupConnection(clearSession);
        const teamSettings = await fetchCurrentTeamSettings(connection);
        return Result.success(new OpenedSession(connection, loginResult.get(), teamSettings));
    }
    return Result.fail(loginResult.err());
};
